<script setup lang="ts">
import MediaImage from '@components/MediaImage.vue';
import type { Media } from '@models/groups/offerContact';

defineProps<{
  title: string,
  media: Media | null
}>();
</script>

<template>
  <div class="real-estate-summary">
    <MediaImage
      v-if="media"
      class="real-estate-summary__picture"
      img-class="real-estate-summary__img"
      :uuid="media.uuid as string"
      :alt="media.description"
      :width="72"
      :height="72"
    />

    <div class="real-estate-summary__content">
      <h2 class="real-estate-summary__title">
        {{ title }}
      </h2>

      <div class="content">
        <slot />
      </div>
    </div>
  </div>
</template>
